export default "__VITE_ASSET__DEkNKx9C__"